<template>
<div>
  <div v-if="!selections">
    loading...
  </div>
  <div v-else :class="{deleted: flags.isDeleted}">
    <a class="title is-4" @click="$emit('click', $event)">
      <span v-html="(selections && selections.coverTitle) || title || '<No Title>'"/>
      <b-tooltip v-if="flags.isLocked"
                 label="Locked for printing.">
        <b-icon icon="lock"></b-icon>
      </b-tooltip>
      <b-tooltip v-if="flags.isDeleted"
                 label="Queued for deletion.">
        <b-icon icon="delete"></b-icon>
      </b-tooltip>
      <b-tooltip v-if="flags.needsRefresh"
                 label="Newly created or duplicated">
        <b-icon type="is-primary" icon="star"></b-icon>
      </b-tooltip>
      <b-tooltip v-if="selections.noteToSelf" :label="selections.noteToSelf">
        <b-icon type="is-warning" icon="note"/>
      </b-tooltip>
    </a>
    <br v-if="selections.coverDescription">
    <div>
      <!--span v-html="selections.coverDescription"/-->
      <a class="subtitle is-6" v-if="selections.coverAuthor" @click="$emit('click', $event)">
        &nbsp;&nbsp;&mdash;(<span v-html="selections.coverAuthor"/>)</a>
      <br/><span><em>{{site}}
          <span v-if="selections.pageCount">, {{selections.pageCount}} pages</span><span v-if="flags.volumes">, {{Object.keys(flags.volumes).length}} Volumes</span>
        </em>
        <span v-if="devMode" class="dev-only">&nbsp;[{{projid}}]</span>
      </span>
    </div>
    <!--{{selections}}-->
  </div>
</div>
</template>

<script>
import Firebase from '../firebase.js'
var db = Firebase.database

export default {
  name: 'MyBooksCard',
  data: function() { return {
    selections: undefined
  }},
  props: {
    projid: { type: String },
    flags: { type: Object },
  },  
  firebase: function() {
    return {
      selections: {
        source: db.ref('/projects/'+this.$store.state.uid+'/'+this.projid+'/selections'),
        asObject: true },
      siteVal: {
        source: db.ref('/projects/'+this.$store.state.uid+'/'+this.projid+'/site'),
        asObject: true },
      titleVal: {
        source: db.ref('/projects/'+this.$store.state.uid+'/'+this.projid+'/title'),
        asObject: true },
      isLockedVal: {
        source: db.ref('/projects/'+this.$store.state.uid+'/'+this.projid+'/isLocked'),
        asObject: true },
    }
  },
  computed: {
    site: function() { return this.siteVal['.value'] },
    title: function() { return this.titleVal['.value'] },
    isLocked: function() { return this.isLockedVal['.value'] },
    devMode: function() { return this.$store.state.dev.developmentClient},
  },
}
</script>

<style scoped>
  .note { width: 50%; min-width: 20em; display: inline-block; }
  .deleted span { color: #ddd !important; text-decoration: line-through;}
  .button.volume { margin-left: 1em; font-weight: bold; }
</style>



// WEBPACK FOOTER //
// src/components/MyBookCard.vue